<template>

  <div class="d-flex justify-content-center">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

  </div>

</template>

<script>
   export default {
     name: "LoaderComponent",
   }
</script>

